<!-- order-details -->
<sd-border-wrapper class="has-no-padding">
  <div class="c__header">
    @if (order?.code) {
      <div class="c__col">
        <p class="is-overline">{{ 'order.number.full' | translate }}</p>
        <p class="is-body-s">{{ 'order.number.short' | translate }} {{ order.code }}</p>
      </div>
    }
    @if (order?.type) {
      <div class="c__col">
        <p class="is-overline">{{ 'order.details.type' | translate }}</p>
        <p class="is-body-s">{{ ((order.type === orderTypeEnum.online) ? 'order.details.online' : '') | translate }}</p>
      </div>
    }
    @if (order?.date) {
      <div class="c__col">
        <p class="is-overline">{{ 'order.details.date' | translate }}</p>
        <p class="is-body-s">{{ order.date }}</p>
      </div>
    }
    @if (order?.totalPrice) {
      <div class="c__col">
        <p class="is-overline">{{ 'order.details.totalPrice' | translate }}</p>
        <p class="is-body-s is-semi-bold">
          {{ order.totalPrice }}
          <sd-converted-price class="is-block is-text-right" [price]="order.totalPrice" [sourceCurrencyIsocode]="order.total?.currencyIso" />
        </p>
        @if (order?.isTaxesIncluded) {
          <p class="c__taxes-included is-caption">
            {{'product.taxesIncluded' | translate }}
          </p>
        }
      </div>
    }
    @if (order?.status) {
      <div class="c__col">
        <p class="is-overline">
          {{ 'order.details.status' | translate }}
        </p>
        <p class="is-body-s is-semi-bold {{order.status.value === statusEnum.success ? 'is-success' : 'is-warning'}}">
          {{ order.status.name | translate }}
        </p>
      </div>
    }

    <div class="c__col c__action_return">
      @if (order?.isReturnEligible) {
        <button sd-button (click)="clickReturnProduct()" [isSmall]="true">
          <span>{{ 'order.details.returnProduct' | translate }}</span>
        </button>
      }
      @if (order?.hasInvoiceDownload) {
        <button sd-button type="button"   icon="icon-printer" (click)="downloadInvoice()" [isSmall]="true" class="c__action-invoice" data-testid="download">
          <span>{{ 'account.order.printmybill' | translate }}</span>
        </button>
        <span>{{ 'order.details.downloadInvoiceTime' | translate }}</span>
      }
    </div>

  </div>
  @if (totalProducts > 0) {
    <sd-accordion-group>
      <sd-accordion
        [title]="(totalProducts > 1 ? 'order.details.articles' : 'order.details.article') | translate: {'article': totalProducts}"
        [titleLevel]="titleLevelAccordion"
        titleCustomClass="is-body-s is-semi-bold"
        [isDrawer]="true"
        [isOpened]="isOpened"
        [iconPos]="positionEnum.right"
      >
        @if (order?.shipments) {
          @for (shipmentStatus of order.shipments; track shipmentStatus) {
            <div class="c__product-customer-container">
              <div class="c__header-status">
                @if (shipmentStatus?.shipmentDate) {
                  <p>
                    <span class="is-overline">{{ 'order.details.shipment' | translate }}</span>
                    <span>{{ shipmentStatus?.shipmentDate }}</span>
                  </p>
                }
                @if (shipmentStatus?.status) {
                  <p>
                    <span class="is-overline">{{ 'order.details.status' | translate }}</span>
                    <span
                      [class]="shipmentStatus.status?.value === statusEnum.error ? 'is-error' :
                      shipmentStatus.status?.value === statusEnum.success ? 'is-success' :
                      shipmentStatus.status?.value === statusEnum.warning ? 'is-warning' : ''"
                    >
                      {{ shipmentStatus.status?.name | translate }}
                    </span>
                  </p>
                }
              </div>
              @for (product of shipmentStatus?.products; track product) {
                <sd-product-customer
                  [indexFollow]="product?.indexFollow !== undefined ? product?.indexFollow : true"
                  [titleLevel]="product?.titleLevel"
                  [links]="product?.links"
                  [hasNoActions]="true"
                  [isReadOnly]="true"
                  [productInfo]="product?.productInfo"
                  [isOrder]="true"
                  [sourceCurrencyIsocode]="order.total?.currencyIso"
                  (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
                />
              }
              @if (shipmentStatus.displayBundleWarningMessage) {
                <p class="is-caption is-text-dark c__bundle-warning">
                  {{ 'order.details.returnBundleWarning' | translate}}
                </p>
              }
              @if (shipmentStatus?.links) {
                <ul class="c__actions is-xs" sd-list-inline>
                  @for (link of shipmentStatus.links; track link) {
                    <li>
                      @if (link?.url) {
                        <sd-link [isButton]="true" [link]="link" [isDisabled]="link.disable" [isSmall]="true">
                          {{ link?.linkName | translate }}
                        </sd-link>
                      }
                    </li>
                  }
                </ul>
              }
            </div>
          }
        }
        <div class="c__addresses">
          <div class="c__address c__shipping-address">
            <p class="is-body-s is-semi-bold">
              {{ 'order.details.shippingAddress' | translate }}
            </p>
            <sd-address-card [readOnly]="true" [address]="order?.shippingAddress" />
          </div>
          <div class="c__address c__billing-address">
            <p class="is-body-s is-semi-bold">
              {{ 'order.details.billingAddress' | translate }}
            </p>
            <sd-address-card [readOnly]="true" [address]="order?.billingAddress" />
          </div>
        </div>
        @if (order?.paymentMode) {
          <div class="c__other-information">
            <sd-payment-mode [isOrderPaymentMode]="true" [titleHidden]="false" [paymentMode]="order?.paymentMode" />
          </div>
        }
      </sd-accordion>
    </sd-accordion-group>
  }
</sd-border-wrapper>
